import { ApiResult, apiWrapperWithError } from "./ApiUtils";

// Returns one line per status or date the sync changes; nothing is saved unless apply is true
export const syncDcStatuses = async (apply: boolean): Promise<ApiResult<string[]>> => {
    return apiWrapperWithError<string[]>(`api/status-sync/dc${apply ? '?apply=true' : ''}`, 'POST', `syncing DC statuses`);
}
